module.exports = __webpack_public_path__ + "static/media/facebook.50f13391.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/facebook.svg
// module id = 10
// module chunks = 0